"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Asterisk = function Asterisk(_ref) {
  var asterisks = _ref.asterisks,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["asterisks"]);
  var totalAsterisks = (0, _toConsumableArray2.default)(Array(asterisks)).map(function (e) {
    return '*';
  }).join('');
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    "aria-hidden": "true"
  }, rest), totalAsterisks);
};

Asterisk.propTypes = {
  /** Customizable number of asterisks. This text is hidden from assistive technology. */
  asterisks: _propTypes.default.number
};
Asterisk.defaultProps = {
  asterisks: 1
};
var _default = Asterisk;
exports.default = _default;